import { UseQueryResult } from '@tanstack/react-query';
import { KlwMenu } from 'components/headers/types/menu';
import { FC } from 'react';
import { IndienenMenuItem } from './indienen';
import { MenuItemParent } from './menu-item-parent';
import { MenuItemRapportage } from './menu-item-rapportage';

interface MainMenuProps {
  menu: UseQueryResult<KlwMenu>;
}
export const MainMenu: FC<MainMenuProps> = ({ menu }) => {
  return (
    <div style={{ display: 'flex', width: 370, flexDirection: 'row', justifyContent: 'space-evenly' }}>
      {menu?.data?.menuItems
        ?.filter(f => f.titel !== 'Rapportage')
        .map(item => (
          <MenuItemParent key={item.titel} menuItem={item} />
        ))}
      <MenuItemRapportage menuItem={menu?.data?.menuItems.find(f => f.titel === 'Rapportage')} />
      <IndienenMenuItem
        isDisabled={!menu?.data?.isCompleet}
        isPilot={menu?.data?.isPilot}
        kringloopwijzerStatusId={menu?.data?.kringloopwijzerStatusId}
        key={'Indienen'}
      />
    </div>
  );
};
